import {
    CREATE_COMPACTING_INWARD_FAILURE_DK,
    CREATE_COMPACTING_INWARD_REQUEST_DK,
    CREATE_COMPACTING_INWARD_SUCCESS_DK,
    CREATE_USER_FORM_COMPACTING_INWARD_DK,
    FETCH_SINGLE_COMPACTING_INWARD_FAILURE_DK,
    FETCH_SINGLE_COMPACTING_INWARD_REQUEST_DK,
    FETCH_SINGLE_COMPACTING_INWARD_SUCCESS_DK,
    FETCH_COMPACTING_INWARD_FAILURE_DK,
    FETCH_COMPACTING_INWARD_REQUEST_DK,
    FETCH_COMPACTING_INWARD_SUCCESS_DK,
    NAVIGATE_COMPACTING_INWARD_DETAILS_DK,
    NAVIGATE_COMPACTING_INWARD_DK,
    COMPACTING_INWARD_USERFORM_RESET_DK,
    UPDATE_COMPACTING_INWARD_FAILURE_DK,
    UPDATE_COMPACTING_INWARD_REQUEST_DK,
    UPDATE_COMPACTING_INWARD_SUCCESS_DK,
    DELETE_COMPACTING_INWARD_REQUEST_DK,
    DELETE_COMPACTING_INWARD_SUCCESS_DK,
    DELETE_COMPACTING_INWARD_FAILURE_DK,
    FETCH_PENDING_COMPACTING_PO_IN_INWARD_REQUEST_DK,
    FETCH_PENDING_COMPACTING_PO_IN_INWARD_SUCCESS_DK,
    FETCH_PENDING_COMPACTING_PO_IN_INWARD_FAILURE_DK,
    SET_ACTIVE_KEY_COMPACTING_INWARD_DK,
    RESET_FORM_DATA_WITHOUT_COMPACTING_INWARD_ID_DK,
    SET_PENDING_GRID_NAME_COMPACTING_INWARD_DK,
    SET_UNIT_NAME_COMPACTING_INWARD_DK,
    FETCH_COMPLETE_COMPACTING_PO_IN_INWARD_REQUEST_DK,
    FETCH_COMPLETE_COMPACTING_PO_IN_INWARD_SUCCESS_DK,
    FETCH_COMPLETE_COMPACTING_PO_IN_INWARD_FAILURE_DK,
    FETCH_SINGLE_DATA_FOR_REPORT_REQUEST_DK,
    FETCH_SINGLE_DATA_FOR_REPORT_SUCCESS_DK,
    FETCH_SINGLE_DATA_FOR_REPORT_FAILURE_DK
} from './compactingInward.actionsType';

export const COMPACTING_INWARD_DK = 'compactingInwardDK';

let initialState = {
    loading: false,
    compactingInward: [],
    pendingCompactingInward: [],
    completeCompactingDc: [],
    reportSingleCompactProgramInwardList: [],
    activeKey: 1,
    compactingInwardId: '',
    detailsId: [],
    compactingInwardForm: {
        fldSupplierInvoiceNo: null,
        fldSupplierInvoiceDate: null,
        fldSupplierInvoiceValue: null,
        fldSupplierDCNo: null,
        fldSupplierDCDate: null,
        fldSupplierName: '',
        fldDiscountValue: 0,
        fldItemsTotalValue: 0,
        fldIsInHouseDelivery: false,
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldSupplierDCValue: null,
        fldIsInHouseProduction: false,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldRoundoff: 0
    },
    selectedCompactingInward: {},
    renderGridBtn: 'pendingGrid',
    unitId: '',
    isCompactingInward: false,
    compactingInwardSelectedValue: null,
    errorMessage: '',
    iperrorMessage: ''
};

export let compactingInwardDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_COMPACTING_INWARD_REQUEST_DK:
        case FETCH_PENDING_COMPACTING_PO_IN_INWARD_REQUEST_DK:
        case CREATE_COMPACTING_INWARD_REQUEST_DK:
        case FETCH_SINGLE_COMPACTING_INWARD_REQUEST_DK:
        case UPDATE_COMPACTING_INWARD_REQUEST_DK:
        case DELETE_COMPACTING_INWARD_REQUEST_DK:
        case FETCH_COMPLETE_COMPACTING_PO_IN_INWARD_REQUEST_DK:
        case FETCH_SINGLE_DATA_FOR_REPORT_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_COMPACTING_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                compactingInward: updatePayload
            };
        case FETCH_PENDING_COMPACTING_PO_IN_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                pendingCompactingInward: updatePayload
            };
        case FETCH_COMPLETE_COMPACTING_PO_IN_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                completeCompactingDc: updatePayload
            };
        case FETCH_SINGLE_DATA_FOR_REPORT_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                reportSingleCompactProgramInwardList: updatePayload?.Inward
            };
        case CREATE_COMPACTING_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                compactingInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                compactingInwardId: updatePayload[0]?.fldID,
                detailsId: updatePayload,
                activeKey: updatePayload[0]?.fldID && payload == true ? 2 : 1
            };
        case FETCH_SINGLE_COMPACTING_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedCompactingInward: updatePayload,
                compactingInwardForm: {
                    ...payload,
                    fldSupplierInvoiceDate: payload?.fldSupplierInvoiceDate && payload?.fldSupplierInvoiceDate.split('T')[0],
                    fldSupplierDCDate: payload?.fldSupplierDCDate && payload?.fldSupplierDCDate.split('T')[0]
                }
            };
        case UPDATE_COMPACTING_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedCompactingInward: {},
                compactingInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                }
            };
        case DELETE_COMPACTING_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                compactingInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                selectedCompactingInward: {}
            };
        case FETCH_COMPACTING_INWARD_FAILURE_DK:
        case FETCH_PENDING_COMPACTING_PO_IN_INWARD_FAILURE_DK:
        case FETCH_SINGLE_COMPACTING_INWARD_FAILURE_DK:
        case CREATE_COMPACTING_INWARD_FAILURE_DK:
        case UPDATE_COMPACTING_INWARD_FAILURE_DK:
        case DELETE_COMPACTING_INWARD_FAILURE_DK:
        case FETCH_COMPLETE_COMPACTING_PO_IN_INWARD_FAILURE_DK:
        case FETCH_SINGLE_DATA_FOR_REPORT_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_COMPACTING_INWARD_DK:
            return {
                ...state,
                loading: false,
                compactingInwardForm: {
                    ...state.compactingInwardForm,
                    [payload.key]: payload.value
                }
            };
        case SET_ACTIVE_KEY_COMPACTING_INWARD_DK:
            return {
                ...state,
                loading: false,
                activeKey: payload
            };
        case SET_PENDING_GRID_NAME_COMPACTING_INWARD_DK:
            return {
                ...state,
                renderGridBtn: payload
            };
        case SET_UNIT_NAME_COMPACTING_INWARD_DK:
            return {
                ...state,
                unitId: payload
            };
        case COMPACTING_INWARD_USERFORM_RESET_DK:
            return {
                ...state,
                compactingInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                compactingInwardId: '',
                detailsId: [],
                activeKey: 1,
                selectedCompactingInward: {}
            };
        case RESET_FORM_DATA_WITHOUT_COMPACTING_INWARD_ID_DK:
            return {
                ...state,
                compactingInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                selectedTeam: {}
            };
        case NAVIGATE_COMPACTING_INWARD_DETAILS_DK:
            return {
                ...state,
                isCompactingInward: true,
                compactingInwardSelectedValue: updatePayload.compactingInwardSelectedValue
            };
        case NAVIGATE_COMPACTING_INWARD_DK:
            return {
                ...state,
                isCompactingInward: false
            };
        default:
            return state;
    }
};
